module.exports = __webpack_public_path__ + "img/direction-right.1472ced3.svg";